<template>
    <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        @keydown.prevent.enter="submit"
    >
        <span
            v-if="!submitted"
        >

            <TextFieldWithValidation
                v-model="password"
                type="password"
                required
                :label="$t('password')"
                name="password"
                autocomplete="current-password"
                placeholder="******"
                rules="required|min:10"
            />
            <TextFieldWithValidation
                v-model="confirmation"
                type="password"
                required
                :label="$t('repeatPassword')"
                name="confirmation"
                autocomplete="current-password"
                placeholder="******"
                :rules="`required|matches:password,${password}`"
            />
        </span>
        <p
            v-else
            class="mb-2"
        >
            {{ $t('passwordResetSuccess') }}
        </p>
        <div class="flex items-center justify-between">
            <AntButton
                v-if="!submitted"
                type="primary"
                :disabled="invalid || !validationObserverReady"
                :loading="loading"
                @click="submit"
            >
                {{ $t('request') }}
            </AntButton>
            <span class="text-gray-500">
                <RouterLink :to="{ name: 'login' }">
                    {{ $t('login') }}
                </RouterLink>
            </span>
        </div>
    </ValidationObserver>
</template>

<script>
import validationObserverMixin from '@/mixins/validationObserver';
import TextFieldWithValidation from '@/components/forms/elements/withValidation/TextFieldWithValidation.vue';
import { Button } from 'ant-design-vue';

export default {
    name: 'ResetPassword',
    components: {
        AntButton: Button,
        TextFieldWithValidation,
    },
    mixins: [validationObserverMixin],
    props: {
        token: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            submitted: false,
            password: '',
            confirmation: '',
            loading: false,
        };
    },
    methods: {
        async submit() {
            if (!await this.$refs.observer.validate()) {
                return;
            }

            this.loading = true;

            const { email } = this.$data;

            this.$http.post('reset-password', { email })
                .then(() => this.submitted = true)
                .catch(this.$refs.observer.setErrors);
        },
    },
};
</script>
